
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getAddDocumentDtoFormGroup() {
return new FormGroup({
    documentId: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      